import React from 'react';
import withStyles from '@mui/styles/withStyles';
import { Routes, Route } from 'react-router-dom';
import { Snackbar } from '@mui/material';
import RouteElement from '../components/Route';
import NotFound from './NotFound';
import Dashboard from './Dashboard/Dashboard';
import Enquiry from './Enquiry/Enquiry';
import EnquiryListing from './Enquiry/EnquiryListing';
import Account from './Account/Account';
import SignIn from './SignIn';
import Styles from './Style/Styles';
import Cremation from './Cremation/Cremation';
import Plaque from './Plaque/Plaque';
import PlaqueListing from './Plaque/PlaqueListing';
import CremationRecordList from './Cremation/CremationRecordList';
import Contacts from './Contacts/Contacts';
import CremationPendingList from './Cremation/CremationPendingList';
import CremationPending from './Cremation/CremationPending';
import RecentlyUpdated from './Recent/RecentlyUpdated';
import Calendar from './Calendar/Calendar';
import Runsheet from './Runsheet/Runsheet';
import Delivery from './Runsheet/Delivery';
import WorkQueue from './WorkQueue/WorkQueue';
import AlertBar from '../components/form/AlertBar';
import Metrics from './MetricDashboard/Metrics';
import { isLocalClient, isLocalServer, serverUrl } from '../environment';
import { PAGE_CREMATIONS, PAGE_ENQUIRIES, PAGE_ORDER_REQUESTS, PAGE_PLAQUES, PAGE_STOCK } from '../utils/strings';
import Users from './Account/Users';
import Scheduler from './Cremation/Scheduler';
import StockList from './Stock/StockList';
import StockItem from './Stock/StockItem';

const localLogin = isLocalClient() && !isLocalServer();

const RemoteSignInRedirect = () => {
    window.location.href = serverUrl + '/Security/cmreact';
    return null;
};

const Main = ({ signedIn }) => (
    <main className={signedIn ? 'main' : ''}>
        <Routes>
            <Route path="/" element={<RouteElement auth title="Dashboard" component={Dashboard} />} />
            <Route path="/metrics" element={<RouteElement auth title="Metrics" component={Metrics} />} />

            <Route path="/work-queue/task/:id?" element={<RouteElement auth title="Task" component={WorkQueue} />} />
            <Route path="/work-queue/:queue/:key?/:id?" element={<RouteElement auth title="Task Queue" component={WorkQueue} />} />
            <Route path="/work-queue" element={<RouteElement auth title="Task Queue" component={WorkQueue} />} />

            <Route path="/calendar/:date?" element={<RouteElement auth title="Calendar" component={Calendar} />} />
            <Route path="/contacts" element={<RouteElement auth title="Contacts" component={Contacts} />} />

            <Route path={PAGE_ENQUIRIES} element={<RouteElement auth title="Bookings" component={EnquiryListing} />} />
            <Route path={PAGE_ORDER_REQUESTS} element={<RouteElement auth title="Booking Requests" component={CremationPendingList} />} />
            <Route path={PAGE_ORDER_REQUESTS + ':id'} element={<RouteElement auth title="Booking Request" component={CremationPending} />} />
            <Route path={PAGE_ENQUIRIES + ':id'} element={<RouteElement auth title="Booking" component={Enquiry} />} />

            <Route path={PAGE_CREMATIONS} element={<RouteElement auth title="Cremations" component={CremationRecordList} />} />
            <Route path={PAGE_CREMATIONS + 'scheduler'} element={<RouteElement auth title="Scheduler" component={Scheduler} />} />
            <Route path={PAGE_CREMATIONS + ':key/:id'} element={<RouteElement auth title="Cremation" component={Cremation} />} />

            <Route path={PAGE_PLAQUES} element={<RouteElement auth title="Plaques" component={PlaqueListing} />} />
            <Route path={PAGE_PLAQUES + ':key/:id'} element={<RouteElement auth title="Plaque" component={Plaque} />} />

            <Route path="/styles" element={<RouteElement auth title="Style Guide" component={Styles} />} />
            <Route path="/users" element={<RouteElement auth title="Users" component={Users} />} />
            <Route path="/account" element={<RouteElement auth title="Account Settings" component={Account} />} />
            <Route path={PAGE_STOCK} element={<RouteElement auth title="Products & Services" component={StockList} />} />
            <Route path={PAGE_STOCK + ':id'} element={<RouteElement auth title="Item" component={StockItem} />} />

            {localLogin && <Route path="/sign-in" element={<RouteElement anon component={SignIn} />} />}
            {!localLogin && <Route path="/sign-in/:id/:hash/:remember?" element={<RouteElement anon component={SignIn} />} />}
            {!localLogin && <Route path="/sign-in" element={<RouteElement anon component={RemoteSignInRedirect} />} />}

            {/* Footer Links */}
            <Route path="/recent" element={<RouteElement auth title="Your Recent Cremations" component={RecentlyUpdated} />} />
            <Route path="/runsheet" element={<RouteElement auth title="Run Sheet" component={Runsheet} />} />
            <Route path="/delivery" element={<RouteElement auth title="Driver" component={Delivery} />} />

            <Route path="*" element={<RouteElement title="Page Not Found" component={NotFound} />} />
        </Routes>

        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={window.appData && window.appData.newContent}
            message={
                <div style={{ color: 'black', margin: '-30px -24px' }}>
                    <AlertBar variant={'fire'}>
                        We're on fire! We've updated the system with a hotfix.
                        <br />
                        It will be loaded when all tabs are closed.
                    </AlertBar>
                </div>
            }
        />
    </main>
);

export default withStyles({})(Main);
